import React, { useEffect, useRef } from "react";
import Matter from "matter-js";

const Snowfall = () => {
  const sceneRef = useRef(null);
  const engineRef = useRef(null);

  useEffect(() => {
    const engine = Matter.Engine.create();
    engineRef.current = engine;
    const world = engine.world;
    const render = Matter.Render.create({
      element: sceneRef.current,
      engine: engine,
      options: {
        width: window.innerWidth,
        height: window.innerHeight,
        wireframes: false,
        background: "transparent",
      },
    });

    // --- Select all meme containers ---
  const secretContainers = document.querySelectorAll("[data-meme-container='true']");

  if (secretContainers.length === 0) return;

  secretContainers.forEach((meme) => {
    const bounds = meme.getBoundingClientRect();

    // --- Create Static Snow Pile for Each Meme ---
    const snowPile = Matter.Bodies.rectangle(
      bounds.left + bounds.width / 2,
      bounds.top, // Pile up on the top
      bounds.width,
      4, // Small thickness
      { isStatic: true, render: { fillStyle: "white" } }
    );

    Matter.World.add(world, snowPile);
  });


    // --- Generate Snowflakes ---
    const createSnowflake = () => {
      const radius = Math.random() * 5 + 2;
      const snowflake = Matter.Bodies.circle(
        Math.random() * window.innerWidth, // Spread across screen
        0, // Start from top
        radius,
        {
          restitution: 0.3,
          friction: 0.1,
          render: { fillStyle: "Snow" },
        }
      );

      Matter.World.add(world, snowflake);

      // Melting effect (remove after some time)
      setTimeout(() => {
        Matter.World.remove(world, snowflake);
      }, Math.random() * 8000 + 5000);
    };

    // --- Snowfall Interval ---
    const interval = setInterval(() => {
      createSnowflake();
    }, 1000);

    // --- Mouse Interaction (Move Snow) ---
    const mouse = Matter.Mouse.create(render.canvas);
    const mouseConstraint = Matter.MouseConstraint.create(engine, {
      mouse,
      constraint: {
        stiffness: 0.2,
        render: { visible: false },
      },
    });

    Matter.World.add(world, mouseConstraint);

    Matter.Render.run(render);
    const runner = Matter.Runner.create();
    Matter.Runner.run(runner, engine);

    // --- Cleanup on Unmount ---
    return () => {
      clearInterval(interval);
      Matter.World.clear(world, false);
      Matter.Engine.clear(engine);
      Matter.Render.stop(render);
      Matter.Runner.stop(runner);
      render.canvas.remove();
      render.textures = {};
    };
  }, []);

  return (
    <div
      ref={sceneRef}
      style={{
        position: "absolute", // Fixed to prevent page shift
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none", // So it doesn’t interfere with clicks
        zIndex: 1, // Ensure it's above background but below UI
      }}
    />
  );
};

export default Snowfall;


